// eslint-disable-next-line strict
module.exports = null;



/*****************
 ** WEBPACK FOOTER
 ** ./~/axios/lib/helpers/null.js
 ** module id = ./node_modules/axios/lib/helpers/null.js
 ** module chunks = 0
 **/